import { knownEnvironments } from '$constants/environments'

export const SIZE = 16

export const ID = 'env'

export const NAMESPACES = [...knownEnvironments, 'unknown'] as const

export type Namespaces = (typeof NAMESPACES)[number]
